module.exports = __webpack_public_path__ + "img/feeling-hopeless.f513f745.png";